import { createConfig } from "wagmi";
import { http } from "viem";
import { avalancheFuji, avalanche, sepolia } from "viem/chains";

import { isProduction } from "@/helpers";

export const evmNetworks = isProduction
  ? [
      {
        blockExplorerUrls: ["https://snowtrace.io/"],
        chainId: avalanche.id,
        chainName: "Avalanche",
        iconUrls: ["https://app.dynamic.xyz/assets/networks/avax.svg"],
        name: "Avalanche",
        nativeCurrency: {
          decimals: 18,
          name: "Avax",
          symbol: "AVAX",
        },
        networkId: avalanche.id,
        rpcUrls: ["https://api.avax.network/ext/bc/C/rpc"],
        vanityName: "Avalanche",
      },
    ]
  : [
      {
        blockExplorerUrls: ["https://testnet.snowtrace.io/"],
        chainId: avalancheFuji.id,
        chainName: "Avalanche Fuji",
        iconUrls: ["https://app.dynamic.xyz/assets/networks/avax.svg"],
        name: "Avalanche Fuji",
        nativeCurrency: {
          decimals: 18,
          name: "Avax",
          symbol: "AVAX",
        },
        networkId: avalancheFuji.id,
        rpcUrls: ["https://api.avax-test.network/ext/bc/C/rpc"],
        vanityName: "Avalanche Fuji",
      },
    ];

export const config = isProduction
  ? createConfig({
      chains: [avalanche],
      multiInjectedProviderDiscovery: false,
      transports: { [avalanche.id]: http() },
    })
  : createConfig({
      chains: [avalancheFuji],
      multiInjectedProviderDiscovery: false,
      transports: { [avalancheFuji.id]: http() },
    });
